import { z } from "zod"
import { optionSchema } from "@/common/schemas/option.schema"
import { unFormatCurrency } from "@/common/utils/unFormatters"

const feeTemplateApplicableProductsAttributesSchema = z.object({
  label: z.string(),
  value: z.string(),
  type: z.string()
})

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  default_value: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }).refine(value => value !== 'R$ -', { message: 'Campo obrigatório' }),
  enableMinimumConsumption: z.boolean().optional(),
  conditional_minimum_consumption: z.string().optional(),
  kind: optionSchema,
  applicable_entity: optionSchema,
  option_id: optionSchema,
  apply_by_default: z.boolean(),
  calculate_as: optionSchema,
  payment_modality: optionSchema,
  enableApplicableProducts: z.boolean().optional(),
  fee_template_applicable_products_attributes: z.array(feeTemplateApplicableProductsAttributesSchema).optional(),
  enableApplicableCaptureMethods: z.boolean().optional(),
  fee_template_applicable_capture_methods_attributes: z.array(optionSchema).optional(),
  applicable_establishment_commercial_kinds: optionSchema.optional(),
  not_use_if_has_special_fee: z.boolean().optional(),
})
.superRefine((data, ctx) => {
  if (data.enableMinimumConsumption && (!data.conditional_minimum_consumption || unFormatCurrency(data.conditional_minimum_consumption) <= 0)) {
    ctx.addIssue({
      path: ['enableMinimumConsumption'],
      code: z.ZodIssueCode.custom,
      message: 'Caso opte por habilitar o campo de consumo mínimo, é necessário preencher o campo de consumo mínimo'
    })
    ctx.addIssue({
      path: ['conditional_minimum_consumption'],
      code: z.ZodIssueCode.custom,
      message: 'Campo obrigatório'
    })
  }
  if (data.enableApplicableProducts && !data.fee_template_applicable_products_attributes?.length) {
    ctx.addIssue({
      path: ['enableApplicableProducts'],
      code: z.ZodIssueCode.custom,
      message: 'Caso opte por habilitar a seleção de produtos e serviços aplicáveis, é necessário selecionar ao menos um item'
    })
    ctx.addIssue({
      path: ['fee_template_applicable_products_attributes'],
      code: z.ZodIssueCode.custom,
      message: 'Campo obrigatório'
    })
  }
  if (data.enableApplicableCaptureMethods && !data.fee_template_applicable_capture_methods_attributes?.length) {
    ctx.addIssue({
      path: ['enableApplicableCaptureMethods'],
      code: z.ZodIssueCode.custom,
      message: 'Caso opte por habilitar a seleção de metodos e capturas aplicáveis, é necessário selecionar ao menos um item'
    })
    ctx.addIssue({
      path: ['fee_template_applicable_capture_methods_attributes'],
      code: z.ZodIssueCode.custom,
      message: 'Campo obrigatório'
    })
  }
})

export const updateSchema = z.object({
  display_name: z
    .string()
    .min(3, { message: 'Tamanho minimo: 3 characteres' })
    .max(64, { message: 'Tamanho máximo: 64 characteres' }),
})

export type FeeTemplateValidationSchema = z.infer<typeof createSchema>

export type FeeTemplateUpdateValidationSchema = z.infer<typeof updateSchema>
